import type { admin as pt } from '../pt/admin';
// English mirror of ../pt/admin.ts (shape checked against its pt twin).
export const admin: typeof pt = {
  permissions: {
    title: 'Permissions',
    subtitle: 'Access to modules and reserved data',
    adminOnly: 'Restricted to portal administrators.',
    tabs: {
      modules: 'Module access',
      reserved: 'Reserved data',
    },
    subject: {
      role: 'Role',
      user: 'User',
      group: 'Group',
    },
    permission: {
      viewReserved: 'View reserved data',
    },
    role: {
      onboarding: 'Onboarding',
      hr: 'HR',
      researcher: 'Researcher',
      direction: 'Board',
      admin: 'Admin',
    },
    change: 'Change',
    remove: 'Remove',
    modulesPanel: {
      introPart1:
        'Link a collaborator who already exists in the portal to one or more modules and set whether they can only ',
      introView: 'view',
      introPart2: ' or also ',
      introEdit: 'edit',
      introPart3: '. Access is linked at login through the ',
      introUserName: 'User Name',
      introPart4: ' field of the record. Administrators see every module.',
      newTitle: 'New assignment',
      collaborator: 'Collaborator',
      collaboratorPlaceholder: 'Search by name, code or email…',
      module: 'Module',
      level: 'Level',
      levelView: 'View',
      levelEdit: 'Edit',
      submitBusy: 'Assigning…',
      submit: 'Grant access',
      grantsTitle: 'Assignments',
      filterPlaceholder: 'Filter by collaborator…',
      allModules: 'All modules',
      emptyNone:
        'No assignments. Everyone sees only their own profile; administrators see everything.',
      emptyFiltered: 'No assignment matches the filter.',
      colCollaborator: 'Collaborator',
      colUserName: 'User Name',
      colModule: 'Module',
      colLevel: 'Level',
      noMatch: '— (no match)',
    },
    reserved: {
      introPart1: 'Fine-tune who can see reserved data, by role, user or group. A',
      introDeny: ' deny',
      introPart2: ' rule always prevails over an allow rule. Administrators see everything.',
      newTitle: 'New rule',
      subject: 'Subject',
      subjectRole: 'Role',
      subjectUser: 'User',
      subjectGroup: 'Group (id/name)',
      subjectUserPlaceholder: 'username',
      subjectGroupPlaceholder: 'group-id',
      permission: 'Permission',
      effect: 'Effect',
      effectAllow: 'Allow',
      effectDeny: 'Deny',
      submitBusy: 'Adding…',
      submit: 'Add rule',
      rulesTitle: 'Rules',
      empty: 'No rules (only the default values apply).',
      colSubject: 'Subject',
      colIdentifier: 'Identifier',
      colPermission: 'Permission',
      colEffect: 'Effect',
    },
  },
  ad: {
    title: 'Active Directory',
    subtitle: 'AD account creation — OU, username and attribute map',
    adminOnly: 'Restricted to portal administrators.',
    intro:
      'Configure how accounts are created in AD: target OU, username rules and the record field → AD attribute map. The connection (LDAPS) is set through environment variables.',
    saved: 'Saved.',
    statusTitle: 'Status',
    mode: 'Mode',
    configured: 'Configured',
    url: 'URL',
    yes: 'Yes',
    no: 'No',
    settingsTitle: 'Settings',
    defaultOu: 'Target OU (DN)',
    upnSuffix: 'UPN suffix',
    patternsLabel: 'Username rules (one per line; tokens: {f} {l} {first} {last})',
    saveBusy: 'Saving…',
    save: 'Save settings',
    mappingTitle: 'Record field → AD attribute map',
    fieldKeyPlaceholder: 'Record field (e.g. department)',
    adAttributePlaceholder: 'AD attribute (e.g. department)',
    add: 'Add',
    noMappings: 'No mappings.',
    colFieldKey: 'Record field',
    colAdAttribute: 'AD attribute',
    remove: 'Remove',
    test: {
      title: 'Test username suggestion',
      firstName: 'First name',
      lastName: 'Last name',
      submit: 'Suggest',
      resultLabel: 'Suggestion: ',
      noResult: 'No rule produced an available username.',
    },
  },
  vehicles: {
    title: 'Vehicles',
    countOne: '{n} record',
    countMany: '{n} records',
    create: 'New record',
    searchPlaceholder: 'Search by plate, collaborator, location, card…',
    search: 'Search',
    empty: 'No vehicle records.',
    colCollaborator: 'Collaborator',
    colPlate: 'Plate',
    colVehicle: 'Vehicle',
    colZone: 'Zone',
    colLocation: 'Location',
    colCards: 'Cards',
    colStatus: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Delete the record for vehicle {plate}?',
    zone: {
      internal: 'Internal',
      external: 'External',
    },
    form: {
      editTitle: 'Edit record',
      createTitle: 'New vehicle record',
      collaborator: 'Collaborator *',
      collaboratorPlaceholder: 'Search collaborator by name, code or email…',
      change: 'Change',
      plate: 'Plate *',
      vehicle: 'Vehicle (make/model)',
      zoneLabel: 'Zone *',
      location: 'Location *',
      locationSelect: 'Select…',
      locationPlaceholder: 'Define the locations in Settings → Global Configuration',
      cards: 'Physical cards (comma-separated ids)',
      cardsPlaceholder: 'e.g. 00123, 00124',
      notes: 'Notes',
      active: 'Active',
      cancel: 'Cancel',
      saveBusy: 'Saving…',
      save: 'Save',
    },
  },
  placeholder: {
    inPreparation: 'Module in preparation. Features will be added soon.',
  },
};
